export default __webpack_public_path__ + "static/media/img-home.c034239e.jpg";